import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TOrganizationForm } from "@/features/organization/types/organizationForm";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { Grid } from "@mui/material";
import { Textarea } from "@/modules/irohana-components/elements/Textarea";
import { FormField } from "@/modules/irohana-components/elements/FormField";

export const OtherInfoForm: FC = () => {
  const { control } = useFormContext<TOrganizationForm>();

  return (
    <InnerBox title="その他情報（顧客未開示の情報）" p={3} bordered>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={12}>
          <FormField control={control} name="note" label="備考">
            <Textarea />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
